import { Stream } from 'types/stream';

// Extracts file ID from Lumeo stream URI
// Format: `lumeo://<file_id>`
// Returns undefined if `stream_type` is not `'file'` or URI doesn't contain `lumeo://`
export function getLumeoFileIdFromStreamUri({ stream_type, uri }: Stream) {
  if (!(stream_type === 'file') || !uri.includes('lumeo://')) {
    return;
  }

  return uri.replace('lumeo://', '');
}

// Streamable streams include:
// 1. Streams from cameras and pipelines
// 2. URI RTSP streams that are assigned to a Gateway and are monitored (ie status is not unknown)
export function isStreamable(stream: Stream) {
  const isUriRTSPStream =
    stream.source === 'uri_stream' &&
    stream.uri.includes('rtsp://') &&
    Boolean(stream.gateway_id);
  return (
    stream.source === 'camera_stream' ||
    stream.source === 'pipeline_stream' ||
    (isUriRTSPStream && stream.status !== 'unknown')
  );
}
